import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import utils from "../../Utils";
import strings from "../../Utils/strings";
import OffCanvas from "../common/offCanvas";
import ClinicConfiguration from "../manageClinic/clinicConfiguration";
import ClinicProfile from "../manageClinic/clinicProfile.jsx";
import ClinicTiming from "../manageClinic/clinicTiming/clinicTiming";

function EditProfileDropdown({ isEdited, isEditedConfigure, isEditClinicTiming, refreshClinic, hospitalDetails, refreshProfile }) {
  const { t, i18n } = useTranslation();
  const [showCanvas, setShowCanvas] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showTimingCanvas, setShowTimingCanvas] = useState(false);
  const [showConfigCanvas, setShowConfigCanvas] = useState(false);
  const [showEditClinicTimingCanvas, setShowEditClinicTimingCanvas] = useState(false);

  const handleSelect = (selectedOption, value) => {
    setSelectedOption(selectedOption);
    if (selectedOption.value === strings.value.edit_profile) {
      setShowCanvas(true);
    } else if (selectedOption.value === strings.value.editClinicProfile) {
      setShowEditClinicTimingCanvas(true);
    } else if (selectedOption.value === strings.value.edit_config) {
      setShowConfigCanvas(true);
    }
    setSelectedOption(value);
  };

  const handleClinicProfileCanvasChanges = (child) => {
    setShowCanvas(child);
    setShowCanvas(false);
    setSelectedOption(null);
  };

  const handleClinicTimingCanvasChanges = (child) => {
    setShowTimingCanvas(child);
    setShowTimingCanvas(false);
    setSelectedOption(null);
  };

  const handleEditClinicTimingCanvasChanges = (child) => {
    setShowEditClinicTimingCanvas(child);
    setShowEditClinicTimingCanvas(false);
    setSelectedOption(null);
  };

  const handleClinicConfigCanvasChanges = (child) => {
    setShowConfigCanvas(child);
    setShowConfigCanvas(false);
    setSelectedOption(null);
  };

  var emailIcon = (
    <i className="ri-edit-2-line me-1">
      <span className="edit">{strings.btn.edit}</span>
    </i>
  );

  const handleEditedProfile = (data) => {
    isEdited(data);
  };

  const handleEditedConfiguration = (data) => {
    isEditedConfigure(data);
  };

  const handleEditClinicTiming = (data) => {
    isEditClinicTiming(data);
  };

  return (
    <>
      <Select
        isSearchable={false}
        placeholder={
          <div>
            <i className="ri-edit-2-line">
              <span className="edit">{t("btnEdit")}</span>
            </i>
          </div>
        }
        options={utils.constants.clinicProfileEditList}
        styles={utils.appStyles.customDropDownStyles}
        onChange={handleSelect}
        value={selectedOption}
        menuPortalTarget={document.body}
      />
      <OffCanvas show={showCanvas} onHide={handleClinicProfileCanvasChanges} title={utils.constants.clinicProfileEditList[0].label}>
        <ClinicProfile
          clinicProfileCanvas={handleClinicProfileCanvasChanges}
          isEdited={handleEditedProfile}
          refresh={() => refreshClinic()}
          hospitalDetails={hospitalDetails}
          refreshProfile={refreshProfile}
        />
      </OffCanvas>
    </>
  );
}

export default EditProfileDropdown;
